import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export const UpdateUserBlockedData = async (id: string): Promise<any> => {
  try {
    const response = await axios.patch(`/student/toggleBlockStudent/${id}`);
    return { data: response.data };
  } catch (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any
  ) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
